import { AppMiddleware } from '../../Store/App/middleware';
import { AuthMiddleware } from '../../Store/Auth/middleware';
import { FilterMiddleware } from '../../Store/Filter/middleware';
import { PersistMiddleware } from '../../Store/Persist/middleware';
import { StoreConfigurator } from '../../Store';
import { StoreGateway } from '../Store/StoreGateway';

const storeGateway = new StoreGateway();

const appMiddleware = new AppMiddleware();
const authMiddleware = new AuthMiddleware();
const filterMiddleware = new FilterMiddleware();
const persistMiddleware = new PersistMiddleware();

const storeConfigurator = new StoreConfigurator([
    appMiddleware.middleware,
    authMiddleware.middleware,
    filterMiddleware.middleware,
    persistMiddleware.middleware,
]);

export const ServiceContainer = {
    storeConfigurator,
    storeGateway,
};
